(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var $ = jQuery;
var linkedProductsSlider = function linkedProductsSlider() {
  var element = document.querySelector('.cross-sells');
  if (!element) return;
  var slideWrapper = element.querySelector('ul.products');
  if ($(slideWrapper).hasClass('slick-initialized')) return;
  $(slideWrapper).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    infinite: true,
    prevArrow: "<button type=\"button\" class=\"slick-prev\"></button>",
    nextArrow: "<button type=\"button\" class=\"slick-next\"></button>",
    mobileFirst: true,
    centerMode: true,
    centerPadding: '100px',
    responsive: [{
      breakpoint: 1024,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1
      }
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 2
      }
    }]
  });
};
(function ($) {
  document.addEventListener('DOMContentLoaded', function (event) {
    linkedProductsSlider();
  });
  window.addEventListener('resize', function () {
    linkedProductsSlider();
  });
})(jQuery);

},{}]},{},[1]);
